<template>
  <div class="flex" style="margin:10px;width:100%" @click="$emit('click')">
    <div class="box grow flex column justify-center info">
      <span style="margin-bottom:10px;">{{subject}}</span>
      <span class="fs-14 secondary-text" style="margin-left:5px;margin-bottom:3px;">{{$t('common.sentAt')}} {{moment(sendDate)}}</span>
      <span class="fs-14 secondary-text" style="margin-left:5px;margin-bottom:3px;">{{$t('common.at')}} {{recipient}}</span>
      <span v-if="readDate" class="fs-14 secondary-text" style="margin-left:5px;margin-bottom:3px;">{{$t('common.readAt')}} {{moment(readDate)}}</span>
    </div>
    <div class="overdue flex pr-20" style="flex-direction:column">
      <span class="" style="text-align:right;"><el-tag :type="getTagType(status)" style="margin-left:10px;">{{$t('emails.statuses.'+status.code)}}</el-tag></span>
    </div>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'Email-Communication-Tile',
	props: {
    sendDate : {
      type : String,
      require : true
    },
    subject : {
      type : String,
      require : true
    },
    recipient : {
      type : String,
      require : true
    },
    status : {
      type : Object,
      required:true
    },
    readDate : {
      type : String,
      default : null
    }
	},
  data() {
    return {

    };
  },components: {

  },
	methods: {
    moment(datetime){
      return  moment(datetime).format('LL');
    },
    getTagType(status){
      if(status.code=="PENDING"){
        return "info"
      }else if(status.code=="DELIVERED"){
        return "success";
      }else if(status.code=="FAILED"){
        return "warning";
      }else if(status.code=="PERMANENT_FAILED"){
        return "error";
      }
    }
	}
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.item-list {
  //margin: 0 auto;
  width: 100%;
  padding: 0px 30px;
  box-sizing: border-box;

  .item {
    margin: 10px 0;
    padding: 5px;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .5s .25s;


    .info {
      word-break: break-word;

    }

    &:hover {
      //margin: 15px -20px;
      //padding: 10px;
      background-color: lighten($background-color, 20%);
      border-radius: 5px;
      box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

    }

  }
}

</style>
